var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _g, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _g2, _path140, _path141, _path142, _path143, _path144, _g3, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _g4, _path159, _path160, _path161, _path162, _g5, _path163, _path164, _path165, _path166, _path167, _g6, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _g7, _path191, _path192, _path193;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 479,
    height: 471,
    viewBox: "0 0 479 471",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.96 404.052C86.3829 384.336 101.711 326.054 65.6517 258.777C29.5926 191.499 25.3295 164.115 61.0438 106.446C96.758 48.7767 174.011 16.3436 246.005 64.5834C317.999 112.823 370.545 97.8643 414.096 135.441C457.646 173.017 463.49 225.468 411.863 272.2C360.237 318.933 342.236 428.337 200.96 404.052Z",
    fill: "#92E3A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M200.96 404.052C86.3829 384.336 101.711 326.054 65.6517 258.777C29.5926 191.499 25.3295 164.115 61.0438 106.446C96.758 48.7767 174.011 16.3436 246.005 64.5834C317.999 112.823 370.545 97.8643 414.096 135.441C457.646 173.017 463.49 225.468 411.863 272.2C360.237 318.933 342.236 428.337 200.96 404.052Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5802 251.439V87.1067H75.797",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5898 278.304V272.313",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.345 87.1067H258.976V299.339H61.5802",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.363 87.1067H107.248",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M251.552 94.3977H69.0047V292.058H251.552V94.3977Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M243.064 108.264V185.141H77.4926V178.132",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4926 161.685V102.028H243.064",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5022 172.734V165.914",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M215.109 193.223H251.552",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M202.148 193.223H207.302",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0047 193.223H195.988",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M151.105 185.141V181.448H166.366V183.549H160.283V185.141",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3209 259.474C69.3209 259.474 71.85 261.358 73.6319 272.756C73.6319 272.756 76.6975 254.547 80.4145 254.265C84.1316 253.982 83.346 266.115 83.346 266.115C83.346 266.115 83.9591 260.133 86.8714 260.406C89.7838 260.68 86.8714 272.756 86.8714 272.756C86.8714 272.756 90.3681 263.336 93.6732 263.506C96.9783 263.675 91.4794 280.565 91.4794 280.565C91.4794 280.565 99.9673 274.518 103.407 277.475C106.846 280.433 101.491 287.894 101.491 287.894C101.491 287.894 113.667 285.294 115.554 292.312",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M115.583 285.511C115.583 285.511 120.89 282.091 125.057 283.683C125.057 283.683 122.404 279.708 125.057 277.278C127.711 274.847 131.121 283.683 131.121 283.683C131.121 283.683 131.505 268.884 136.812 269.629C142.119 270.373 136.812 283.683 136.812 283.683C136.812 283.683 146.287 275.431 148.557 278.304C150.828 281.178 147.043 285.511 147.043 285.511C147.043 285.511 152.724 283.721 156.892 287.894C156.892 287.894 163.243 281.517 170.304 280.603C170.304 280.603 165.609 267.208 167.889 264.504C170.17 261.801 174.289 276.194 174.289 276.194C174.289 276.194 176.1 266.831 182.03 266.115C182.03 266.115 177.086 263.468 178.552 259.474C180.018 255.48 186.839 260.416 186.839 260.416C186.839 260.416 184.032 253.379 188.467 251.448C192.903 249.517 194.752 257.336 194.752 257.336C194.752 257.336 195.988 249.14 201.199 249.592C206.411 250.044 204.725 259.483 204.725 259.483C204.725 259.483 209.639 251.947 212.274 252.748C217.533 254.274 215.933 266.124 215.933 266.124C215.933 266.124 223.281 261.104 225.168 263.411C227.209 265.908 217.504 272.323 217.504 272.323C217.504 272.323 224.795 273.114 229.326 277.287",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M251.552 262.177C251.552 262.177 250.718 254.641 243.064 254.265C235.409 253.888 245.171 270.75 245.171 270.75C245.171 270.75 238.858 265.616 236.597 267.198C234.336 268.781 243.064 277.475 243.064 277.475C243.064 277.475 238.877 273.707 234.442 274.847C230.006 275.987 236.961 288.129 236.961 288.129C230.405 286.828 223.598 287.61 217.523 290.362",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M327.693 363.254V269.355H435.219",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M431.311 279.067H336.344V366.532",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M355.351 326.77V287.894H361.568V295.91H369.865V292.312H377.28V296.673H387.291V287.894H397.532V293.791H403.05V290.362H412.936V313.262",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M403.05 293.791V326.77",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M398.327 298.727V304.615",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M398.327 308.835V333.016",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M387.291 296.683V318.405",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M387.674 325.565V332.328",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M377.28 296.683V308.835",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M377.28 316.305V341.908",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M369.865 295.91V326.092",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M361.568 295.91V307.327",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M361.568 313.262V340.401",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M355.351 332.328V344.584",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M342.523 344.583H417.995",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M403.05 344.584V336.737",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M387.674 338.809V344.216",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M413.779 300.432H421.098",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M342.811 351.423H412.936",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M357.861 371.365V362.227H370.851V368.115H381.303V379.598H387.291V362.576H400.559V366.532H408.712",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M400.559 366.532V376.329",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M387.674 383.742V390.336",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M381.303 379.598V388.283",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M370.851 368.115V373.098",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M431.636 68.926H202.061V224.893H431.636V68.926Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M431.636 68.926H202.061V84.3466H431.636V68.926Z",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M295.064 175.862L289.68 168.496C289.679 166.957 289.599 165.42 289.441 163.889C289.239 163.201 285.973 158.143 285.896 156.947C285.884 156.375 285.81 155.807 285.676 155.251C285.676 155.251 283.999 155.666 284.018 156.673C284.037 157.681 284.219 161.082 284.219 161.082C284.219 161.082 279.851 158.576 279.362 157.917C278.874 157.257 273.547 153.414 273.049 152.839C272.551 152.265 270.52 152.227 270.281 152.839L270.568 153.546L268.891 154.328L270.012 157.597C269.692 158.332 269.497 159.116 269.437 159.914C269.62 160.319 270.213 162.74 270.213 162.74C270.213 162.74 269.849 163.107 269.897 164.388C269.945 165.67 277.101 172.216 278.519 172.923C280.213 173.623 281.946 174.223 283.712 174.722L288.205 180.44L295.064 175.862Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M284.21 161.082C283.374 162.954 283.159 165.037 283.597 167.035",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M270.558 153.546C272.005 154.092 273.816 156.749 274.649 157.568C275.403 158.237 276.21 158.845 277.063 159.386",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M270.003 157.568C271.191 157.323 271.995 157.775 271.967 158.915C271.938 160.055 274.505 161.788 274.505 161.788",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M270.204 162.711C270.204 162.711 271.037 161.251 271.698 161.92C272.359 162.589 272.57 164.303 273.787 164.661",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M365.075 167.855C365.075 167.855 346.173 169.004 342.006 170.681C338.586 172.066 314.531 187.637 314.531 187.637C314.531 187.637 300.381 177.143 296.271 173.507C295.478 173.13 294.626 172.888 293.752 172.791L291.596 171.444L286.298 178.782L287.783 180.807C287.783 180.807 288.023 184.076 288.684 184.896C297.478 195.757 314.32 210.961 316.849 212.459C319.378 213.956 341.814 200.9 341.814 200.9L345.982 224.921H412.898C412.898 224.921 412.726 182.767 409.909 179.536C407.092 176.305 374.808 163.635 374.808 163.635L365.075 167.855Z",
    fill: "#757575",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M387.674 152.604C387.674 152.604 381.677 156.56 384.857 169.202C384.857 169.202 375.823 175.551 366.885 169.146C366.885 169.146 368.945 159.066 366.885 157.041",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M387.674 152.604C387.674 152.604 381.677 156.56 384.857 169.202C384.857 169.202 375.823 175.551 366.885 169.146C366.885 169.146 368.945 159.066 366.885 157.041",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M408.712 181.495C408.712 181.495 400.559 190.717 399.611 206.505",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M372.834 127.273C372.834 127.273 367.489 126.482 365.621 132.925C364.533 136.872 364.973 141.074 366.857 144.719L376.686 135.648L372.834 127.273Z",
    fill: "#263238"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M385.844 156.447C392.732 148.365 397.599 134.894 387.252 129.515C367.288 119.135 360.687 139.416 364.04 158.256C365.075 164.068 373.103 161.477 378.975 159.377",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M385.844 156.447C392.732 148.365 397.599 134.894 387.252 129.515C367.288 119.135 360.687 139.416 364.04 158.256C365.075 164.068 373.103 161.477 378.975 159.377",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M371.896 138.879C371.896 138.879 375.191 139.755 376.025 141.488",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M367.125 138.022C366.736 137.834 366.304 137.747 365.871 137.77C365.439 137.793 365.019 137.925 364.653 138.154",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M371.838 143.344C371.781 143.919 372.039 144.418 372.413 144.456C372.787 144.493 373.141 144.05 373.198 143.514C373.256 142.977 372.997 142.43 372.624 142.393C372.25 142.355 371.896 142.76 371.838 143.344Z",
    fill: "#263238"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M364.691 141.601C364.644 142.185 364.902 142.685 365.276 142.722C365.649 142.76 366.004 142.317 366.061 141.78C366.119 141.243 365.86 140.706 365.477 140.669C365.094 140.631 364.749 141.027 364.691 141.601Z",
    fill: "#263238"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M382.769 147.121C382.769 147.121 379.675 151.53 377.596 152.943C376.253 153.789 374.634 154.105 373.064 153.828C373.064 153.828 370.411 150.607 366.54 150.56C365.538 149.932 364.399 149.548 363.216 149.439L363.436 144.521C363.436 144.521 360.495 155.062 360.773 158.84C361.051 162.617 370.497 165.236 375.22 164.181C379.943 163.126 382.347 155.901 383.784 149.109C383.89 148.544 382.769 147.121 382.769 147.121Z",
    fill: "#263238"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M363.791 152.99C363.791 152.99 367.527 154.752 370.851 154.337",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M385.863 133.689C387.089 132.747 383.947 128.696 382.185 128.781C380.422 128.866 371.771 129.186 371.771 129.186C371.771 129.186 369.951 119.822 384.512 124.881C386.898 125.71 387.664 127.905 389.801 129.026C391.937 130.147 394.83 136.044 394.006 141.074C393.182 146.104 390.452 154.931 385.499 157.578C385.499 157.578 383.794 157.408 384.829 156.25C389.705 150.852 384.599 140.697 383.784 149.09L382.07 148.082C382.056 147.161 382.152 146.241 382.357 145.341C382.721 143.033 380.125 138.314 385.863 133.689Z",
    fill: "#263238"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M385.116 146.509C385.116 146.509 388.249 142.854 390.145 144.098C392.042 145.341 390.768 149.75 389.753 150.852C388.737 151.954 387.913 152.199 386.505 153.96C385.097 155.722 383.325 155.128 383.631 153.715",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M385.116 146.509C385.116 146.509 388.249 142.854 390.145 144.098C392.042 145.341 390.768 149.75 389.753 150.852C388.737 151.954 387.913 152.199 386.505 153.96C385.097 155.722 383.325 155.128 383.631 153.715",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M375.536 143.815C375.641 145.859 374.377 147.583 372.662 147.668C370.947 147.753 369.548 146.17 369.443 144.126C369.338 142.082 370.602 140.358 372.317 140.273C374.032 140.188 375.411 141.771 375.536 143.815Z",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M366.703 141.959C366.818 144.003 365.544 145.727 363.877 145.821C362.21 145.916 360.764 144.314 360.649 142.27C360.534 140.226 361.817 138.502 363.523 138.417C365.228 138.333 366.598 139.915 366.703 141.959Z",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M367.613 140.207C367.613 141.149 362.651 146.717 362.593 147.941C362.536 149.166 367.211 149.241 367.211 149.241",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M367.613 140.207C367.613 141.149 362.651 146.717 362.593 147.941C362.536 149.166 367.211 149.241 367.211 149.241",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M366.703 141.959C366.703 141.959 368.188 141.592 369.434 143.561",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M375.555 144.531L377.165 144.767L386.199 145.388",
    stroke: "#263238",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M403.05 186.516L401.249 184.321C401.249 184.321 386.074 186.026 379.368 194.919C379.368 194.919 366.914 189.135 355.705 191.951L355.38 195.898L379.895 210.32L389.475 206.402L403.05 186.516Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M405.512 185.188L402.925 202.144C402.925 202.144 388.651 208.304 385.681 213.259L384.972 213.354L381.619 213.815L379.809 213.288C375.378 212.019 370.865 211.05 366.301 210.386C364.716 210.146 363.109 210.086 361.511 210.207L351.854 195.408C351.854 195.408 366.789 193.374 377.117 196.85L382.06 196.511L382.242 196.36C383.727 195.164 394.131 187.034 405.512 185.188Z",
    fill: "#92E3A9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_19",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 351,
    y: 185,
    width: 55,
    height: 29
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M405.512 185.188L402.925 202.144C402.925 202.144 388.651 208.304 385.681 213.259L384.972 213.354L381.619 213.815L379.809 213.288C375.378 212.019 370.865 211.05 366.301 210.386C364.716 210.146 363.109 210.086 361.511 210.207L351.854 195.408C351.854 195.408 366.789 193.374 377.117 196.85L382.06 196.511L382.242 196.36C383.727 195.164 394.131 187.034 405.512 185.188Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_19)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M384.781 209.397L382.242 196.35C383.717 195.164 394.121 187.034 405.502 185.188L402.916 202.144C402.916 202.144 388.641 208.304 385.672 213.259L384.963 213.354L384.781 209.397Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M379.866 210.32L379.799 213.278C375.369 212.01 370.856 211.041 366.291 210.377C366.494 207.385 367.684 204.539 369.681 202.273C371.678 200.007 374.373 198.443 377.356 197.82L379.866 210.32Z",
    fill: "black",
    fillOpacity: 0.7
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M405.512 185.188L402.925 202.144C402.925 202.144 388.651 208.304 385.681 213.259L384.972 213.354L381.619 213.815L379.809 213.288C375.378 212.019 370.865 211.05 366.301 210.386C364.716 210.146 363.109 210.086 361.511 210.207L351.854 195.408C351.854 195.408 366.789 193.374 377.117 196.85L382.06 196.511L382.242 196.36C383.727 195.164 394.131 187.034 405.512 185.188Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M384.723 217.395C379.607 217.074 369.874 209.369 369.874 209.369C369.289 207.931 368.467 206.597 367.441 205.422C366.052 204.056 367.901 202.916 367.901 202.916C367.901 202.916 366.282 201.889 365.362 201.324C364.442 200.759 366.052 199.27 366.052 199.27C366.052 199.27 372.997 200.212 373.716 199.958C374.434 199.704 381.102 203.943 382.137 204.056C383.542 204.081 384.927 203.726 386.141 203.029C386.831 202.464 388.967 198.931 390.356 198.244C391.745 197.556 394.188 197.565 393.019 199.044C391.851 200.523 392.061 203.82 391.487 204.282C390.912 204.743 389.963 209.698 389.963 211.403L397.532 218.205L393.221 223.979L384.723 217.395Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M367.872 202.916C369.232 203.066 370.559 203.431 371.8 203.999",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M373.026 205.61C373.026 205.61 372.595 207.334 372.48 207.598C372.365 207.862 373.907 209.548 373.687 210.32C373.467 211.093 375.249 213.146 375.249 213.146",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M371.282 207.598C369.951 206.968 368.67 206.241 367.45 205.422",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M367.575 164.699L370.89 171.265L384.512 163.842L387.511 170.417L373.61 179.093L370.938 172.301L365.534 177.416L363.705 169.146L367.575 164.699Z",
    fill: "#757575",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M409.947 179.507C413.252 182.983 425.007 208.474 426.138 224.893H390.328V223.423L386.419 221.172C386.419 221.172 388.843 212.788 395.75 214.098L397.762 216.924L402.216 220.221C402.216 220.221 410.034 220.418 412.304 222.632",
    fill: "#757575"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M409.947 179.507C413.252 182.983 425.007 208.474 426.138 224.893H390.328V223.423L386.419 221.172C386.419 221.172 388.843 212.788 395.75 214.098L397.762 216.924L402.216 220.221C402.216 220.221 410.034 220.418 412.304 222.632",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M402.216 220.258C402.216 220.258 406.556 214.107 412.936 216.707",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M400.559 210.32C401.952 212.863 403.193 215.483 404.276 218.167",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M341.814 200.872C341.814 200.872 339.161 185.668 339.898 180.412L341.814 200.872Z",
    fill: "#757575"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M341.814 200.872C341.814 200.872 339.161 185.668 339.898 180.412",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M336.507 186.337C336.507 186.337 337.982 193.807 341.297 197.81L336.507 186.337Z",
    fill: "#757575"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M336.507 186.337C336.507 186.337 337.982 193.807 341.297 197.81",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M314.531 187.646C314.531 187.646 318.698 191.037 316.044 199.497L314.531 187.646Z",
    fill: "#757575"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M314.531 187.646C314.531 187.646 318.698 191.037 316.044 199.497",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M370.257 177.68C370.257 177.855 370.204 178.027 370.105 178.173C370.006 178.319 369.864 178.432 369.699 178.499C369.534 178.566 369.353 178.583 369.178 178.548C369.003 178.513 368.842 178.427 368.717 178.303C368.591 178.178 368.506 178.019 368.473 177.847C368.439 177.674 368.458 177.496 368.528 177.335C368.597 177.173 368.714 177.035 368.864 176.939C369.013 176.843 369.188 176.793 369.366 176.794C369.484 176.794 369.601 176.817 369.71 176.862C369.818 176.907 369.917 176.972 370 177.054C370.083 177.137 370.148 177.234 370.192 177.342C370.237 177.449 370.259 177.564 370.257 177.68Z",
    fill: "#263238"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M367.901 190.642C368.398 190.642 368.801 190.245 368.801 189.756C368.801 189.267 368.398 188.871 367.901 188.871C367.403 188.871 367 189.267 367 189.756C367 190.245 367.403 190.642 367.901 190.642Z",
    fill: "#263238"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M366.54 217.837C367.038 217.837 367.441 217.441 367.441 216.952C367.441 216.463 367.038 216.066 366.54 216.066C366.043 216.066 365.64 216.463 365.64 216.952C365.64 217.441 366.043 217.837 366.54 217.837Z",
    fill: "#263238"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M249.981 137.042H261.266L266.918 127.424L261.266 117.816H249.981L244.338 127.424L249.981 137.042Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M248.342 158.124L242.7 148.516H231.414",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 127.424H244.213L249.856 117.816L244.213 108.198H232.928L227.285 117.816L232.928 127.424Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M249.981 117.816H261.266L266.918 108.198L261.266 98.5896H249.981L244.338 108.198L249.981 117.816Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M248.342 117.816C248.34 117.519 248.428 117.228 248.595 116.98C248.762 116.732 248.999 116.539 249.278 116.424C249.557 116.31 249.864 116.279 250.16 116.337C250.457 116.394 250.729 116.537 250.943 116.747C251.156 116.957 251.301 117.225 251.36 117.516C251.418 117.808 251.387 118.11 251.271 118.384C251.154 118.658 250.958 118.892 250.706 119.056C250.454 119.219 250.158 119.306 249.856 119.304C249.455 119.304 249.07 119.147 248.786 118.868C248.502 118.589 248.342 118.211 248.342 117.816Z",
    fill: "#263238"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M226.289 99.1266C227.125 99.1266 227.803 98.4603 227.803 97.6383C227.803 96.8163 227.125 96.1499 226.289 96.1499C225.453 96.1499 224.776 96.8163 224.776 97.6383C224.776 98.4603 225.453 99.1266 226.289 99.1266Z",
    fill: "#263238"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M246.829 158.124C246.829 157.83 246.917 157.542 247.084 157.297C247.25 157.052 247.486 156.862 247.763 156.749C248.04 156.636 248.344 156.607 248.638 156.664C248.931 156.722 249.201 156.864 249.413 157.072C249.624 157.28 249.768 157.545 249.827 157.834C249.885 158.122 249.855 158.422 249.741 158.694C249.626 158.966 249.432 159.198 249.183 159.362C248.934 159.525 248.642 159.612 248.342 159.612C247.941 159.612 247.556 159.456 247.272 159.177C246.988 158.897 246.829 158.519 246.829 158.124Z",
    fill: "#263238"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M231.414 150.004C232.25 150.004 232.928 149.338 232.928 148.516C232.928 147.694 232.25 147.027 231.414 147.027C230.578 147.027 229.901 147.694 229.901 148.516C229.901 149.338 230.578 150.004 231.414 150.004Z",
    fill: "#263238"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M277.82 108.452C277.82 108.156 277.91 107.866 278.077 107.619C278.245 107.373 278.484 107.181 278.763 107.068C279.041 106.955 279.348 106.926 279.644 106.984C279.94 107.043 280.211 107.186 280.424 107.397C280.636 107.607 280.781 107.875 280.838 108.166C280.896 108.457 280.864 108.759 280.748 109.032C280.631 109.306 280.434 109.539 280.182 109.702C279.931 109.866 279.635 109.952 279.334 109.95C279.134 109.95 278.936 109.911 278.752 109.836C278.568 109.761 278.401 109.65 278.26 109.511C278.119 109.372 278.008 109.206 277.932 109.025C277.857 108.843 277.819 108.649 277.82 108.452Z",
    fill: "#263238"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M242.585 150.004C243.421 150.004 244.098 149.338 244.098 148.516C244.098 147.694 243.421 147.027 242.585 147.027C241.749 147.027 241.071 147.694 241.071 148.516C241.071 149.338 241.749 150.004 242.585 150.004Z",
    fill: "#263238"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M265.366 108.452C265.366 108.156 265.455 107.867 265.623 107.62C265.79 107.374 266.028 107.182 266.306 107.069C266.585 106.955 266.891 106.926 267.186 106.983C267.482 107.041 267.753 107.184 267.966 107.393C268.179 107.603 268.324 107.87 268.383 108.16C268.442 108.451 268.412 108.752 268.296 109.026C268.181 109.299 267.986 109.533 267.735 109.698C267.485 109.862 267.19 109.95 266.889 109.95C266.485 109.95 266.098 109.792 265.812 109.511C265.526 109.231 265.366 108.85 265.366 108.452Z",
    fill: "#263238"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M248.342 137.042C248.34 136.745 248.428 136.454 248.595 136.206C248.762 135.959 248.999 135.765 249.278 135.651C249.557 135.536 249.864 135.506 250.16 135.563C250.457 135.621 250.729 135.764 250.943 135.974C251.156 136.184 251.301 136.451 251.36 136.743C251.418 137.034 251.387 137.336 251.271 137.61C251.154 137.884 250.958 138.118 250.706 138.282C250.454 138.446 250.158 138.532 249.856 138.53C249.455 138.528 249.072 138.37 248.788 138.092C248.505 137.813 248.345 137.436 248.342 137.042Z",
    fill: "#263238"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M266.918 108.452H279.343",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M249.856 137.042L242.585 148.516",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M232.928 108.198L226.289 97.6382",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M219.918 183.492C220.936 182.591 222.078 181.836 223.31 181.25C223.36 181.552 223.525 181.825 223.773 182.01C224.021 182.196 224.332 182.281 224.641 182.249C225.322 182.145 226.088 181.485 226.557 181.966C226.749 182.154 226.787 182.456 226.989 182.635C227.602 183.191 228.646 181.994 229.336 182.446C229.518 182.569 229.613 182.776 229.805 182.899C229.956 182.963 230.119 182.996 230.284 182.996C230.449 182.996 230.612 182.963 230.763 182.899C232.474 182.515 234.231 182.366 235.984 182.456L244.022 182.512L243.409 182.201",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M219.487 190.086C219.554 189.776 219.729 189.5 219.982 189.304C220.235 189.108 220.549 189.005 220.871 189.012C221.193 189.02 221.501 189.138 221.744 189.347C221.986 189.555 222.147 189.84 222.199 190.152C222.398 190.061 222.575 189.93 222.72 189.768C222.865 189.606 222.975 189.416 223.042 189.21C223.559 190.35 225.159 190.444 226.433 190.359L232.114 189.964C233.819 189.841 235.812 189.54 236.578 188.08C237.42 189.591 237.756 191.325 237.536 193.035C238.063 191.804 238.749 190.645 239.577 189.587C239.749 190.19 239.922 190.793 240.084 191.395C244.041 188.673 249.454 190.453 254.244 189.86",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M219.995 198.818C219.977 198.645 220.025 198.471 220.129 198.33C220.233 198.19 220.387 198.092 220.56 198.055C220.614 198.226 220.703 198.385 220.821 198.52C220.939 198.656 221.084 198.767 221.248 198.845C221.411 198.924 221.589 198.969 221.771 198.977C221.952 198.985 222.134 198.957 222.304 198.894C222.988 198.612 223.573 198.14 223.99 197.537C224.133 197.651 224.299 197.734 224.477 197.78C224.655 197.826 224.84 197.834 225.022 197.804C225.203 197.773 225.376 197.705 225.528 197.604C225.681 197.503 225.809 197.371 225.906 197.217C226.333 197.898 226.687 198.621 226.96 199.374C227.477 198.074 229.23 197.867 230.658 197.876H242.154",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M308.859 96.2913C306.115 96.2258 303.424 97.0427 301.195 98.618C298.436 100.351 295.811 103.271 296.501 106.418C297.191 109.564 300.965 111.231 304.29 111.863C307.148 112.41 310.057 112.663 312.969 112.616C314.091 112.633 315.21 112.516 316.303 112.268C317.408 111.96 318.479 111.547 319.503 111.034L326.917 107.605C327.933 107.134 329.073 106.531 329.351 105.457C329.696 104.129 328.537 102.895 327.435 102.094C323.273 99.1671 318.14 97.8952 313.065 98.5332",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M300.055 103.337C300.491 102.856 301.055 102.503 301.684 102.32C301.559 102.68 301.559 103.071 301.684 103.431C301.856 103.771 302.383 103.94 302.642 103.657C302.9 103.375 302.958 102.923 303.245 103.064L303.59 103.818C304.06 103.657 304.424 103.281 304.883 103.083C305.407 102.91 305.965 102.859 306.512 102.932C310.625 103.14 314.749 103.017 318.842 102.565",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M306.761 107.388C306.821 107.195 306.926 107.019 307.067 106.874C307.209 106.728 307.383 106.617 307.575 106.549C307.355 106.785 307.623 107.19 307.949 107.247C308.28 107.252 308.607 107.185 308.907 107.049C309.27 106.956 309.643 106.906 310.018 106.898L317.002 106.427",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M309.741 116.958C307.72 124.039 303.531 130.336 297.742 134.993C291.954 139.65 284.847 142.441 277.389 142.986",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M277.504 140.942C276.149 141.765 274.941 142.803 273.931 144.013C274.528 143.89 275.149 143.932 275.724 144.135C276.299 144.338 276.806 144.693 277.188 145.162",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M307.441 143.184L308.313 145.068L309.559 143.617C309.792 143.788 309.955 144.035 310.018 144.314C310.114 144.578 310.258 144.87 310.526 144.945C310.794 145.021 311.13 144.663 310.928 144.465C311.105 144.582 311.305 144.661 311.515 144.695C311.725 144.729 311.94 144.718 312.145 144.663C312.327 144.663 312.49 144.531 312.672 144.484C312.889 144.437 313.111 144.418 313.333 144.427H326.276",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M308.045 153.546C308.106 153.395 308.205 153.262 308.334 153.16C308.463 153.058 308.616 152.991 308.779 152.964C308.942 152.938 309.109 152.953 309.264 153.009C309.419 153.064 309.557 153.159 309.664 153.282C309.707 153.403 309.772 153.514 309.855 153.612C309.971 153.692 310.112 153.727 310.252 153.709C310.393 153.692 310.521 153.623 310.612 153.518C310.823 153.329 310.957 153.075 311.178 152.905C311.781 152.444 312.643 152.802 313.381 152.999C314.325 153.194 315.295 153.245 316.255 153.15L323.603 152.773",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M308.275 161.553C308.519 161.559 308.759 161.485 308.955 161.341C309.151 161.198 309.293 160.994 309.357 160.762C309.479 160.782 309.591 160.838 309.68 160.922C309.769 161.006 309.83 161.114 309.856 161.233C310.207 161.019 310.508 160.733 310.737 160.394C315.469 160.451 320.208 160.451 324.954 160.394",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M308.265 167.535C308.558 167.654 308.886 167.662 309.185 167.558C309.484 167.453 309.733 167.244 309.884 166.969C310.185 167.209 310.394 167.541 310.478 167.911C310.667 167.786 310.88 167.7 311.105 167.659C311.329 167.619 311.559 167.624 311.781 167.676C311.963 167.676 312.145 167.798 312.327 167.846C312.787 167.961 313.262 168.003 313.735 167.968L330.251 167.733",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M263.919 205.62L271.421 204.904C271.494 204.913 271.568 204.904 271.637 204.878C271.705 204.852 271.766 204.81 271.814 204.754C271.862 204.699 271.895 204.633 271.91 204.562C271.924 204.491 271.921 204.417 271.9 204.348V199.638C271.918 199.481 271.877 199.324 271.785 199.195C271.723 199.14 271.65 199.097 271.571 199.07C271.492 199.042 271.408 199.03 271.325 199.035C269.696 198.894 266.027 198.093 264.619 199.176C263.21 200.26 263.929 204.009 263.919 205.62Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M266.065 201.418C266.161 201.861 266.247 202.304 266.343 202.756C267.48 202.523 268.646 202.462 269.802 202.577",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M269.888 207.654C269.818 207.76 269.779 207.884 269.777 208.01C269.774 208.137 269.808 208.262 269.873 208.37C269.939 208.479 270.035 208.568 270.149 208.626C270.263 208.684 270.392 208.71 270.52 208.7C271.028 208.606 271.43 207.937 271.9 208.144",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M264.724 196.793C264.819 196.653 264.953 196.543 265.11 196.476C265.268 196.41 265.441 196.39 265.61 196.419C265.779 196.448 265.935 196.524 266.06 196.639C266.185 196.754 266.274 196.903 266.314 197.066L268.115 196.859",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M279.669 212.411C282.224 212.411 284.778 212.411 287.333 212.411C289.319 212.437 291.304 212.321 293.273 212.063C293.493 212.051 293.703 211.965 293.866 211.818C294.002 211.626 294.06 211.391 294.029 211.159V199.704C294.029 199.572 282.294 199.205 280.924 200.137C278.165 202.04 279.669 209.482 279.669 212.411Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M283.827 203.095L285.656 203.142C285.327 204.366 284.807 205.532 284.114 206.599C283.865 206.929 283.568 207.344 283.75 207.711C284.708 207.862 285.829 207.947 286.432 207.221C287.218 206.279 286.528 204.8 287.122 203.745L287.352 205.978L288.147 206.722C288.354 206.949 288.614 207.124 288.904 207.231C289.049 207.28 289.208 207.279 289.353 207.228C289.497 207.177 289.62 207.078 289.699 206.948",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M289.153 214.333C289.757 214.116 290.006 215.228 290.628 215.388C291.251 215.548 291.586 214.738 292.113 214.38C292.363 214.217 292.665 214.148 292.962 214.187C293.26 214.225 293.533 214.367 293.732 214.587",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M284.21 196.209C284.785 196.35 284.555 197.292 284.986 197.697C285.417 198.102 286.135 197.697 286.624 197.311C287.113 196.925 288.004 196.755 288.186 197.311",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M431.636 224.676H202.061V240.615H431.636V224.676Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M389.159 230.95H239.155V234.341H389.159V230.95Z",
    fill: "#263238"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M324.225 232.674C324.225 233.164 324.078 233.643 323.801 234.05C323.524 234.458 323.131 234.775 322.67 234.963C322.21 235.15 321.703 235.199 321.214 235.104C320.726 235.008 320.277 234.772 319.924 234.426C319.572 234.079 319.332 233.638 319.235 233.157C319.138 232.677 319.187 232.179 319.378 231.726C319.569 231.273 319.892 230.886 320.306 230.614C320.72 230.342 321.208 230.197 321.706 230.197C322.374 230.197 323.015 230.458 323.488 230.922C323.96 231.387 324.225 232.017 324.225 232.674Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M424.202 229.594H417.995V235.698H424.202V229.594Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M413.789 229.594H407.581V235.698H413.789V229.594Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M219.986 229.528H209.17V235.764H219.986V229.528Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M209.045 76.6316H249.856",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M425.821 76.4903C425.823 76.9587 425.684 77.4171 425.42 77.8074C425.157 78.1977 424.781 78.5022 424.341 78.6823C423.902 78.8624 423.417 78.9101 422.95 78.8191C422.483 78.7282 422.053 78.5028 421.717 78.1716C421.38 77.8403 421.15 77.4182 421.058 76.9586C420.966 76.4991 421.014 76.0229 421.197 75.5905C421.38 75.1581 421.69 74.7889 422.087 74.5298C422.484 74.2707 422.95 74.1334 423.426 74.1353C424.062 74.1353 424.671 74.3834 425.12 74.825C425.569 75.2667 425.821 75.8657 425.821 76.4903Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M416.347 76.6316C416.347 77.0974 416.206 77.5527 415.943 77.94C415.68 78.3273 415.306 78.6291 414.868 78.8073C414.431 78.9856 413.949 79.0322 413.485 78.9414C413.02 78.8505 412.593 78.6262 412.258 78.2968C411.923 77.9675 411.695 77.5479 411.603 77.091C411.51 76.6342 411.558 76.1607 411.739 75.7304C411.92 75.3001 412.227 74.9323 412.621 74.6735C413.015 74.4147 413.478 74.2766 413.952 74.2766C414.587 74.2766 415.196 74.5247 415.645 74.9664C416.094 75.408 416.347 76.007 416.347 76.6316Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M406.872 76.7824C406.87 77.2478 406.728 77.7021 406.464 78.0882C406.2 78.4742 405.825 78.7746 405.387 78.9514C404.949 79.1282 404.468 79.1735 404.004 79.0816C403.54 78.9896 403.114 78.7646 402.78 78.4349C402.446 78.1052 402.219 77.6855 402.127 77.229C402.036 76.7724 402.084 76.2994 402.265 75.8696C402.447 75.4398 402.754 75.0726 403.148 74.8142C403.541 74.5559 404.004 74.418 404.477 74.418C404.792 74.418 405.105 74.4792 405.396 74.5981C405.687 74.7171 405.952 74.8914 406.174 75.1111C406.397 75.3307 406.573 75.5915 406.693 75.8783C406.812 76.1651 406.873 76.4723 406.872 76.7824Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M224.91 388.292H202.224L189.943 384.468L186.111 383.271L184.99 394.641L50.659 394.886C50.659 394.886 52.7092 389.8 56.0526 382.339C63.2663 366.24 76.4867 339.054 88.0498 327.948C97.4382 318.933 120.89 318.679 120.89 318.679C123.284 317.118 126.093 316.285 128.966 316.286C133.277 316.493 165.868 319.969 167.889 320.996C169.297 321.798 170.504 322.899 171.425 324.218C171.425 324.218 182.844 319.253 194.062 323.728C205.28 328.202 224.91 388.292 224.91 388.292Z",
    fill: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_19",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 316,
    width: 175,
    height: 79
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M224.91 388.292H202.224L189.943 384.468L186.111 383.271L184.99 394.641L50.659 394.886C50.659 394.886 52.7092 389.8 56.0526 382.339C63.2663 366.24 76.4867 339.054 88.0498 327.948C97.4382 318.933 120.89 318.679 120.89 318.679C123.284 317.118 126.093 316.285 128.966 316.286C133.277 316.493 165.868 319.969 167.889 320.996C169.297 321.798 170.504 322.899 171.425 324.218C171.425 324.218 182.844 319.253 194.062 323.728C205.28 328.202 224.91 388.292 224.91 388.292Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_19)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M189.943 384.468L186.111 383.272L184.99 394.641L50.659 394.886C50.659 394.886 52.7092 389.8 56.0526 382.339C61.2354 382.216 67.0792 381.953 67.0792 381.953L70.0873 372.278C70.0873 372.278 74.8102 367.371 80.7115 370.262C80.5147 369.531 80.5557 368.756 80.8289 368.049C81.102 367.341 81.5936 366.735 82.2347 366.316C84.5148 364.827 93.8648 369.603 93.8648 369.603C93.8648 369.603 98.3674 361.125 99.9002 355.577C101.433 350.028 102.449 363.424 102.449 363.424C102.449 363.424 106.281 357.263 106.281 355.577C106.281 353.891 113.351 372.278 113.351 372.278C113.351 372.278 122.701 373.381 125.23 374.323C127.759 375.265 152.935 376.207 161.04 374.323C169.144 372.439 155.292 383.743 155.292 383.743C155.292 383.743 169.528 388.453 177.575 385.363C185.622 382.273 189.224 378.967 189.224 378.967C189.224 378.967 189.521 381.256 189.943 384.468Z",
    fill: "black",
    fillOpacity: 0.7
  }))), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M224.91 388.292H202.224L189.943 384.468L186.111 383.271L184.99 394.641L50.659 394.886C50.659 394.886 52.7092 389.8 56.0526 382.339C63.2663 366.24 76.4867 339.054 88.0498 327.948C97.4382 318.933 120.89 318.679 120.89 318.679C123.284 317.118 126.093 316.285 128.966 316.286C133.277 316.493 165.868 319.969 167.889 320.996C169.297 321.798 170.504 322.899 171.425 324.218C171.425 324.218 182.844 319.253 194.062 323.728C205.28 328.202 224.91 388.292 224.91 388.292Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M182.547 359.241C180.552 362.007 178.276 364.567 175.755 366.881",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M169.116 372.373C159.356 379.461 147.885 383.926 135.835 385.325",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M211.067 369.16C211.067 369.16 214.554 367.032 217.61 367.729C220.666 368.426 223.195 371.393 223.195 371.393C223.195 371.393 248.563 369.33 254.32 369.509C260.078 369.688 272.963 373.399 272.963 373.399C272.963 373.399 279.209 372.156 279.88 372.41C280.55 372.665 278.529 393.568 278.529 393.568H196.141C192.098 393.568 189.1 387.812 186.063 383.29C191.295 365.298 193.97 346.68 194.014 327.967",
    fill: "#BFBFBF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_19",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 327,
    width: 95,
    height: 67
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M211.067 369.16C211.067 369.16 214.554 367.032 217.61 367.729C220.666 368.426 223.195 371.393 223.195 371.393C223.195 371.393 248.563 369.33 254.32 369.509C260.078 369.688 272.963 373.399 272.963 373.399C272.963 373.399 279.209 372.156 279.88 372.41C280.55 372.665 278.529 393.568 278.529 393.568H196.141C192.098 393.568 189.1 387.812 186.063 383.29C191.295 365.298 193.97 346.68 194.014 327.967",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_19)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.675 393.549H196.16C192.117 393.549 189.119 387.793 186.082 383.272C189.086 373.121 191.223 362.742 192.472 352.242C192.472 352.242 196.457 358.054 194.033 364.79L196.457 358.054C196.457 358.054 198.785 365.27 196.457 371.384C194.129 377.497 192.472 379.249 192.472 379.249C192.472 379.249 195.346 382.942 198.392 381.953C201.439 380.964 204.753 386.955 204.753 386.955C204.753 386.955 212.072 387.228 213.596 386.955C214.295 386.832 223.77 390.045 233.675 393.549Z",
    fill: "black",
    fillOpacity: 0.7
  }))), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M211.067 369.16C211.067 369.16 214.554 367.032 217.61 367.729C220.666 368.426 223.195 371.393 223.195 371.393C223.195 371.393 248.563 369.33 254.32 369.509C260.078 369.688 272.963 373.399 272.963 373.399C272.963 373.399 279.209 372.156 279.88 372.41C280.55 372.665 278.529 393.568 278.529 393.568H196.141C192.098 393.568 189.1 387.812 186.063 383.29C191.295 365.298 193.97 346.68 194.014 327.967",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M163.971 304.068V324.189C161.377 325.927 158.691 327.527 155.924 328.984C150.339 331.895 143.173 334.777 138.91 333.138C131.179 330.152 126.169 318.679 126.169 318.679C134.513 312.424 135.519 304.068 136.783 300.093L163.971 304.068Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M122.126 320.214C122.126 320.214 129.205 335.371 137.799 338.112C146.392 340.853 160.944 330.152 160.944 330.152",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4705 338.555C83.4705 338.555 96.8825 348.822 99.1338 352.28C101.385 355.737 99.1338 388.292 99.1338 388.292",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2111 371.685C73.1145 366.673 78.6709 372.156 83.4705 373.145C88.2701 374.134 98.8848 368.802 106.846 373.145C114.807 377.488 114.807 375.971 114.807 375.971C114.807 375.971 123.141 382.226 118.84 394.745L50.6303 394.868C50.6303 394.868 46.0798 385.306 61.0342 371.666",
    fill: "#BFBFBF"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2111 371.685C73.1145 366.673 78.6709 372.156 83.4705 373.145C88.2701 374.134 98.8847 368.802 106.846 373.145C114.807 377.488 114.807 375.971 114.807 375.971C114.807 375.971 123.141 382.226 118.84 394.745L50.6303 394.868C50.6303 394.868 46.0798 385.306 61.0342 371.666",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M132.051 352.308L150.052 384.684L150.617 388.321L147.743 385.805L129.177 353.664C129.45 353.17 129.875 352.772 130.391 352.529C130.907 352.285 131.487 352.208 132.051 352.308Z",
    fill: "#92E3A9",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M114.96 377.667C116.319 377.279 117.716 377.029 119.127 376.922C120.651 376.922 130.02 370.112 133.2 369.603C136.381 369.094 142.1 373.757 145.012 374.502C147.925 375.246 147.743 378.976 149.448 380.464C151.153 381.953 148.691 383.63 146.574 381.953C146.725 382.535 146.735 383.143 146.601 383.729C146.468 384.315 146.196 384.862 145.808 385.325C145.808 385.325 146.382 387.36 145.808 388.292H112.086C112.086 388.292 111.578 381.953 114.96 377.667Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M146.641 381.953L143.604 379.004L135.835 376.555",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M145.884 385.325L141.238 383.271L134.886 382.094",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M134.886 386.955L141.238 387.237L145.884 388.292",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M133.229 369.603C130.355 372.08 133.229 374.69 131.859 376.555C130.489 378.42 128.985 378.976 130.154 381.953",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M174.241 389.865H327.693C327.693 391.197 327.156 392.474 326.198 393.416C325.24 394.357 323.942 394.886 322.587 394.886H186.551C186.018 394.885 185.488 394.803 184.98 394.641L174.049 391.175C173.893 391.129 173.759 391.029 173.672 390.894C173.584 390.759 173.549 390.598 173.572 390.439C173.595 390.28 173.675 390.135 173.798 390.03C173.921 389.925 174.078 389.866 174.241 389.865Z",
    fill: "#92E3A9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_0_19",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 389,
    width: 155,
    height: 6
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M174.241 389.865H327.693C327.693 391.197 327.156 392.474 326.198 393.416C325.24 394.357 323.942 394.886 322.587 394.886H186.551C186.018 394.885 185.488 394.803 184.98 394.641L174.049 391.175C173.893 391.129 173.759 391.029 173.672 390.894C173.584 390.759 173.549 390.598 173.572 390.439C173.595 390.28 173.675 390.135 173.798 390.03C173.921 389.925 174.078 389.866 174.241 389.865Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_0_19)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M327.694 389.865C327.692 391.197 327.155 392.474 326.199 393.417L326.046 393.549C325.106 394.408 323.871 394.886 322.587 394.886H186.551C186.018 394.885 185.488 394.803 184.98 394.641L174.049 391.175C173.892 391.128 173.756 391.027 173.669 390.89C173.581 390.753 173.547 390.589 173.573 390.429C173.598 390.27 173.682 390.124 173.809 390.021C173.935 389.917 174.096 389.862 174.26 389.865H327.694Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M327.693 389.865C327.692 391.197 327.155 392.474 326.199 393.417L326.046 393.549H238.245C237.251 393.549 236.297 393.161 235.593 392.47C234.889 391.78 234.492 390.843 234.49 389.865H327.693Z",
    fill: "black",
    fillOpacity: 0.7
  }))), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M174.241 389.865H327.693C327.693 391.197 327.156 392.474 326.198 393.416C325.24 394.357 323.942 394.886 322.587 394.886H186.551C186.018 394.885 185.488 394.803 184.98 394.641L174.049 391.175C173.893 391.129 173.759 391.029 173.672 390.894C173.584 390.759 173.549 390.598 173.572 390.439C173.595 390.28 173.675 390.135 173.798 390.03C173.921 389.925 174.078 389.866 174.241 389.865Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M234.49 389.865C234.492 390.843 234.889 391.78 235.593 392.47C236.297 393.161 237.251 393.549 238.245 393.549H252.816",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M355.159 327.929V328.051L337.302 389.14C337.036 389.925 336.533 390.611 335.861 391.107C335.188 391.604 334.378 391.887 333.537 391.919H240.515C240.163 391.946 239.81 391.887 239.487 391.745C239.165 391.603 238.884 391.383 238.67 391.106C238.456 390.83 238.317 390.505 238.264 390.161C238.212 389.817 238.248 389.466 238.37 389.14L256.208 328.051C256.472 327.266 256.975 326.579 257.648 326.083C258.321 325.586 259.132 325.303 259.972 325.272H352.994C353.336 325.243 353.679 325.296 353.994 325.428C354.309 325.561 354.586 325.767 354.801 326.03C355.015 326.293 355.16 326.604 355.222 326.935C355.285 327.267 355.263 327.608 355.159 327.929Z",
    fill: "#92E3A9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_0_19",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 238,
    y: 325,
    width: 118,
    height: 67
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M355.159 327.929V328.051L337.302 389.14C337.036 389.925 336.533 390.611 335.861 391.107C335.188 391.604 334.378 391.887 333.537 391.919H240.515C240.163 391.946 239.81 391.887 239.487 391.745C239.165 391.603 238.884 391.383 238.67 391.106C238.456 390.83 238.317 390.505 238.264 390.161C238.212 389.817 238.248 389.466 238.37 389.14L256.208 328.051C256.472 327.266 256.975 326.579 257.648 326.083C258.321 325.586 259.132 325.303 259.972 325.272H352.994C353.336 325.243 353.679 325.296 353.994 325.428C354.309 325.561 354.586 325.767 354.801 326.03C355.015 326.293 355.16 326.604 355.222 326.935C355.285 327.267 355.263 327.608 355.159 327.929Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_0_19)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M355.159 327.929V328.051L337.302 389.14C337.036 389.925 336.533 390.611 335.861 391.107C335.188 391.604 334.378 391.887 333.537 391.919H241.129V391.797L258.957 330.708C259.223 329.923 259.726 329.237 260.398 328.741C261.071 328.244 261.882 327.961 262.722 327.929H355.159Z",
    fill: "white"
  }))), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M355.159 327.929V328.051L337.302 389.14C337.036 389.925 336.533 390.611 335.861 391.107C335.188 391.604 334.378 391.887 333.537 391.919H240.515C240.163 391.946 239.81 391.887 239.487 391.745C239.165 391.603 238.884 391.383 238.67 391.106C238.456 390.83 238.317 390.505 238.264 390.161C238.212 389.817 238.248 389.466 238.37 389.14L256.208 328.051C256.472 327.266 256.975 326.579 257.648 326.083C258.321 325.586 259.132 325.303 259.972 325.272H352.994C353.336 325.243 353.679 325.296 353.994 325.428C354.309 325.561 354.586 325.767 354.801 326.03C355.015 326.293 355.16 326.604 355.222 326.935C355.285 327.267 355.263 327.608 355.159 327.929Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M303.456 359.722C302.664 361.325 301.443 362.687 299.924 363.661C298.405 364.635 296.646 365.185 294.834 365.251C290.925 365.251 288.617 362.274 289.69 358.601C290.331 356.721 291.539 355.077 293.152 353.888C294.766 352.698 296.709 352.019 298.724 351.941H298.896C298.715 352.304 298.568 352.682 298.455 353.071C297.354 356.717 299.605 359.665 303.456 359.722Z",
    fill: "white",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M241.608 388.923L259.014 329.295C259.17 328.838 259.463 328.438 259.855 328.148C260.246 327.859 260.719 327.694 261.208 327.675H351.375",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M198.392 394.886H70.0202L71.5722 391.703C71.5722 391.703 83.7005 392.814 93.3092 389.866C97.5531 388.566 104.087 387.982 110.639 388.057C114.768 388.114 124.818 388.151 131.054 388.123C133.277 388.123 135.021 388.123 135.844 388.066C136.161 388.066 136.477 388.066 136.802 388.066C138.581 388.045 140.357 388.209 142.1 388.556C143.782 388.369 145.475 388.287 147.168 388.311C150.128 388.311 162.86 388.264 166.328 388.311C170.898 388.368 176.176 389.253 181.187 389.932L181.321 389.884V389.95C187.375 390.779 193.047 391.345 196.649 389.884L198.392 394.886Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_0_19",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 70,
    y: 388,
    width: 129,
    height: 7
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M198.392 394.886H70.0202L71.5722 391.703C71.5722 391.703 83.7005 392.814 93.3092 389.866C97.5531 388.566 104.087 387.982 110.639 388.057C114.768 388.114 124.818 388.151 131.054 388.123C133.277 388.123 135.021 388.123 135.844 388.066C136.161 388.066 136.477 388.066 136.802 388.066C138.581 388.045 140.357 388.209 142.1 388.556C143.782 388.369 145.475 388.287 147.168 388.311C150.128 388.311 162.86 388.264 166.328 388.311C170.898 388.368 176.176 389.253 181.187 389.932L181.321 389.884V389.95C187.375 390.779 193.047 391.345 196.649 389.884L198.392 394.886Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_0_19)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M198.392 394.886H98.8848L100.906 391.467C100.906 391.467 106.338 394.585 111.645 392.409C116.953 390.233 122.298 389.046 131.054 388.104C132.964 387.903 134.888 387.878 136.802 388.029C140.614 388.316 144.362 389.154 147.925 390.516C147.925 390.516 153.146 388.274 166.328 388.274C170.898 388.33 176.176 389.216 181.187 389.894L181.321 389.847V389.913C187.375 390.742 193.047 391.307 196.649 389.847L198.392 394.886Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.906 391.467L71.6105 391.703L70.0585 394.887H98.8848L100.906 391.467Z",
    fill: "#92E3A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7086 393.483L100.906 391.467C103.496 392.576 106.291 393.146 109.116 393.144C113.408 393.021 120.191 387.793 133.229 388.048",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.071 388.537C144.476 389.404 147.896 390.534 147.896 390.534C147.896 390.534 152.322 388.029 162.046 388.292",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.906 391.467C100.906 391.467 85.7506 391.731 79.6864 391.863",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.875 394.886C145.957 394.272 146.234 393.699 146.665 393.248C147.097 392.797 147.661 392.49 148.279 392.371C150.425 392.023 151.814 394.632 151.814 394.632",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.896 390.534L148.279 392.371",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.052 392.371C150.052 392.371 156.873 389.31 163.464 389.866",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.245 392.739C146.641 392.277 136.4 389.168 125.92 391.467",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.875 394.01C145.875 394.01 137.253 392.399 129.752 393.52",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.01 393.539C156.733 391.97 162.722 391.573 168.608 392.371C174.404 393.219 180.261 393.603 186.12 393.521",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M198.392 394.886H70.0202L71.5722 391.703C71.5722 391.703 83.7005 392.814 93.3092 389.866C97.5531 388.566 104.087 387.982 110.639 388.057C114.768 388.114 124.818 388.151 131.054 388.123C133.277 388.123 135.021 388.123 135.844 388.066C136.161 388.066 136.477 388.066 136.802 388.066C138.581 388.045 140.357 388.209 142.1 388.556C143.782 388.369 145.475 388.287 147.168 388.311C150.128 388.311 162.86 388.264 166.328 388.311C170.898 388.368 176.176 389.253 181.187 389.932L181.321 389.884V389.95C187.375 390.779 193.047 391.345 196.649 389.884L198.392 394.886Z",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M163.971 320.845V324.189C161.377 325.927 158.691 327.527 155.924 328.984C149.783 323.436 148.912 312.895 148.912 312.895L163.971 320.845Z",
    fill: "#263238"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M137.799 301.581C130.575 291.078 132.051 271.437 141.334 260.717C154.976 245.061 190.575 256.497 190.546 278.615C190.518 281.689 190.249 284.757 189.741 287.79C189.272 290.711 186.695 293.659 185.909 296.57C185.124 299.481 185.44 304.106 185.124 306.932C184.415 313.366 175.362 326.13 172.909 327.515C169.48 329.399 150.942 324.283 146.9 312.593",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M137.799 301.581C130.575 291.078 132.051 271.437 141.334 260.717C154.976 245.061 190.575 256.497 190.546 278.615C190.518 281.689 190.249 284.757 189.741 287.79C189.272 290.711 186.695 293.659 185.909 296.57C185.124 299.481 185.44 304.106 185.124 306.932C184.415 313.366 175.362 326.13 172.909 327.515C169.48 329.399 150.942 324.283 146.9 312.593",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M163.061 288.6C163.061 288.6 168.11 286.792 172.641 288.6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M182.978 288.6C182.978 288.6 186.657 286.792 189.119 288.6",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M167.784 297.041C167.516 298.313 166.635 299.217 165.868 299.057C165.102 298.897 164.594 297.719 164.862 296.438C165.13 295.157 166.012 294.262 166.826 294.432C167.64 294.601 168.052 295.788 167.784 297.041Z",
    fill: "#263238"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M184.032 297.041C183.764 298.313 182.882 299.217 182.116 299.057C181.349 298.897 180.842 297.719 181.11 296.438C181.378 295.157 182.25 294.262 183.074 294.432C183.898 294.601 184.3 295.788 184.032 297.041Z",
    fill: "#263238"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M181.378 290.531C181.378 290.531 178.974 294.629 178.724 298.067C178.475 301.506 182.556 308.627 181.378 310.86C180.2 313.092 175.189 312.979 173.542 311.613",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M181.378 290.531C181.378 290.531 178.974 294.629 178.724 298.067C178.475 301.506 182.556 308.627 181.378 310.86C180.2 313.092 175.189 312.979 173.542 311.613",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M174.433 316.116C171.122 316.577 167.747 316.103 164.699 314.75",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M145.041 291.897C145.041 291.897 147.398 289.656 150.176 290.532C152.954 291.408 153.462 298.849 153.462 298.849L155.483 296.73C155.483 296.73 154.727 292.519 157.754 286.613C160.781 280.707 159.267 273.755 159.267 273.755C159.267 273.755 164.489 275.488 166.299 279.463C166.299 279.463 168.273 275.243 166.299 272.012C166.299 272.012 174.433 274 176.454 279.962C176.454 279.962 178.054 275.488 177.508 273.255C177.508 273.255 183.016 274.989 185.038 280.207C185.038 280.207 186.877 276.232 186.082 273.001C186.082 273.001 188.304 274.885 189.157 280.462C190.817 277.061 191.304 273.222 190.546 269.525C190.546 269.525 193.42 272.756 193.88 275.488C193.88 275.488 196.218 267.537 182.547 256.855C168.876 246.173 145.472 248.594 141.832 256.855C141.832 256.855 143.039 250.77 145.472 248.594C145.472 248.594 138.766 251.533 138.91 257.599C138.91 257.599 132.99 256.855 129.962 260.585C131.818 260.447 133.683 260.53 135.519 260.83C135.519 260.83 127.433 265.54 127.941 276.731C128.449 287.922 135.519 304.049 135.519 304.049L141.056 302.457C141.056 302.457 141.937 294.846 145.041 291.897Z",
    fill: "#263238"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M151.182 294.629C151.182 294.629 146.89 287.178 144.62 286.679C142.349 286.18 138.048 289.166 139.054 293.141C140.06 297.116 140.826 303.823 142.091 304.567C143.355 305.312 145.376 309.786 147.398 308.543C147.664 308.408 147.894 308.214 148.07 307.976C148.246 307.738 148.363 307.463 148.411 307.173C148.46 306.883 148.438 306.585 148.349 306.305C148.259 306.024 148.104 305.768 147.896 305.557",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M151.182 294.629C151.182 294.629 146.89 287.178 144.62 286.679C142.349 286.18 138.048 289.166 139.054 293.141C140.06 297.116 140.826 303.823 142.091 304.567C143.355 305.312 145.376 309.786 147.398 308.543C147.664 308.408 147.894 308.214 148.07 307.976C148.246 307.738 148.363 307.463 148.411 307.173C148.46 306.883 148.438 306.585 148.349 306.305C148.259 306.024 148.104 305.768 147.896 305.557",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M199.187 352.242C198.753 354.078 198.196 355.885 197.52 357.649",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M195.978 361.248C194.451 364.671 192.213 367.741 189.406 370.263",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M223.214 371.393C221.902 371.223 219.229 372.853 216.776 374.954",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M214.975 376.621C213.059 378.571 211.574 380.634 211.574 381.953",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M75.682 366.315C75.682 366.315 81.133 367.804 81.1809 372.401",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1066 341.221C97.0114 342.216 97.8347 343.281 98.5686 344.405",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M100.724 348.286C101.796 350.574 102.374 353.057 102.42 355.577C102.42 363.329 100.149 367.823 100.149 367.823",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M129.205 333.619C130.651 334.94 132.198 336.149 133.833 337.236",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M138.642 340.062C143.537 342.492 149.87 344.32 156.441 342.709",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.911 257.251C150.623 256.994 152.354 256.883 154.085 256.921",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.604 257.053C161.289 257.486 167.056 259.097 170.639 263.958",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.283 253.473C160.283 253.473 169.068 253.568 175.362 257.891",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.834 259.992C178.96 261.15 179.863 262.5 180.497 263.977",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.641 260.934C146.641 260.934 155.263 263.92 158.262 269.261",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.464 263.958C144.332 266.503 145.677 269.383 146.421 272.436",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.957 276.628C146.969 277.753 146.863 278.877 146.641 279.981",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.659 267.434C136.215 268.542 135.847 269.678 135.557 270.834",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.877 274.122C134.374 277.06 134.335 280.056 134.762 283.005",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M249.722 411.635H370.621V394.886H33.827V411.635H101.922",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M249.722 411.635H370.621V394.886H33.827V411.635H101.922",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M241.042 411.635H223.875",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeImg);
export default __webpack_public_path__ + "static/media/home-img.debdf262c75b7e4ad52097297fa491a2.svg";
export { ForwardRef as ReactComponent };